// Wenn keine Azure-Konfiguration in .env vorhanden ist, läuft die App im
// "Lokal-Modus": MSAL wird nicht initialisiert, SharePoint-Sektion ist
// deaktiviert. Lokale Ordner-Auswahl funktioniert unabhängig davon.

const tenantId = import.meta.env.VITE_AZURE_TENANT_ID?.trim();
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID?.trim();

export const isM365Configured =
  !!tenantId &&
  !!clientId &&
  tenantId !== "00000000-0000-0000-0000-000000000000" &&
  clientId !== "00000000-0000-0000-0000-000000000000";
